import { FC, useCallback, useEffect, useState } from "react";
import styles from "./Model.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import whatsapp from "../../../images/icons/whatsapp.svg";
import locationIcon from "../../../images/icons/location.svg";
import phoneIcon from "../../../images/icons/phone.svg";
import languagesIcon from "../../../images/icons/languages.svg";
import GallerySlider from "../../../components/GallerySlider/GallerySlider";
import { getUserById } from "../../../api/user";
import { IUserData } from "../../../types/user";
import { calculateAge } from "../../../helpers/calculate-age";
import Loader from "../../../components/Loader/Loader";
import { useAppSelector } from "../../../services/hooks";

import { Comments } from "../../../components/ui/Comments/Comments";
import { ErrorPage } from "../../ErrorPage/ErrorPage";

export const ModelComponent: FC<{ id: number }> = ({ id }) => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [girl, setGirl] = useState<IUserData | null>(null);
  const [newComment, setNewComment] = useState("");

  const { user } = useAppSelector((state) => state.user);
  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const data: IUserData = await getUserById(id);
      if (!data) throw new Error();

      setGirl(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading || !girl || !girl.model)
    return (
      <div className="loader-container">
        <Loader size={100} borderWidth={7} color="#ac2386" />
      </div>
    );

  return (
    <section className={`section ${styles.container}`}>
      <div className={styles.columns_comp}>
        <div>
          {girl.gallery && girl.gallery.length > 0 ? (
            <div>
              <GallerySlider
                images={girl.gallery.map((photo) => photo.photoUrl)}
              />
            </div>
          ) : (
            <img
              src="https://placehold.co/400"
              alt="Alt photo"
              className={styles.photoPlaceholder}
            />
          )}
          <div className={styles.likes}>
            <h3 className={`${styles.h3} ${styles.ttu}`}>DIENSTLEISTUNGEN</h3>
            {girl.service.length > 0 ? (
              <ul>
                {girl.service.map(({ serviceName, description }) => (
                  <li className={styles.likes__item} key={serviceName}>
                    <span>
                      <span className={styles.ttu}>{serviceName}:</span>{" "}
                      {description}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={styles.text}>Nicht gefunden</div>
            )}
          </div>
        </div>

        <div>
          <div>
            <h3 className={`${styles.h3} ${styles.ttu}`}>Beschreibung</h3>
            <p className={styles.text}>
              {girl.model?.dataValues?.description
                ? girl.model.dataValues?.description
                : "Nicht gefunden"}
            </p>
          </div>
          <div>
            <h3 className={styles.character__title}>Profil</h3>
            <ul className={styles.character}>
              <li>
                <p className={styles.character__name}>Wachstum</p>
                <span className={styles.character__text}>
                  {girl.model.dataValues?.height
                    ? girl.model.dataValues?.height
                    : "-"}
                </span>
              </li>
              <li>
                <p className={styles.character__name}>Brust</p>
                <span className={styles.character__text}>
                  {girl.model.dataValues?.breast
                    ? girl.model.dataValues?.breast
                    : "-"}
                </span>
              </li>
              <li>
                <p className={styles.character__name}>Gewicht</p>
                <span className={styles.character__text}>
                  {girl.model.dataValues?.weight
                    ? girl.model.dataValues?.weight
                    : "-"}
                </span>
              </li>
              <li>
                <p className={styles.character__name}>Alter</p>
                <span className={styles.character__text}>
                  {girl.model.dataValues?.birthDate
                    ? calculateAge(girl.model.dataValues?.birthDate)
                    : "-"}
                </span>
              </li>
            </ul>
          </div>
          <address className={styles.contacts}>
            <div className={styles.contacts__top}>
              <img src={whatsapp} alt="whats app icon" />
            </div>
            <ul className={styles.contacts__list}>
              <li className={styles.contacts__item}>
                <img src={locationIcon} alt="location icon" />
                <span>
                  Location:{" "}
                  {girl.model.dataValues?.city
                    ? girl.model.dataValues?.city
                    : "-"}
                </span>
              </li>
              <li className={styles.contacts__item}>
                <img src={phoneIcon} alt="language icon" />
                <span>
                  Telefonnummer:{" "}
                  <span className={styles.pink}>
                    +
                    {girl.model.dataValues?.phone
                      ? girl.model.dataValues?.phone
                      : "-"}
                  </span>
                </span>
              </li>
              <li className={styles.contacts__item}>
                <img src={languagesIcon} alt="language icon" />
                <span>
                  <span className={styles.bold}>Sprachen: </span>
                  {girl.language && girl.language.length > 0
                    ? girl.language.map((lang) => lang.language).join(", ")
                    : "-"}
                </span>
              </li>
            </ul>
          </address>
          <div>
            <h3 className={`${styles.h3} ${styles.ttu}`}>Kundenkommentare</h3>
            {user ? (
              <Comments
                dataComments={girl.comments}
                addComment={() => {}}
                description={newComment}
                setDescription={setNewComment}
                userType={user.type}
                handleDelete={() => {}}
              />
            ) : (
              <p className={styles.text}>
                melden Sie sich an, um Kommentare anzuzeigen
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
